export default class InputTask
{
  constructor(id, task) 
  {
    
    this.id = id;
    this.task = task;
  }    
}